import axios from 'axios'
// import config from '@/data/config'

const API_URL = process.env.VUE_APP_BASE_URL

class AuthService {
   login = user => axios
      .post(`${API_URL}auth/login`, {
         username: user.username,
         password: user.password,
      })
      .then(response => {
         localStorage.setItem('userData', JSON.stringify(response.data))
         return response.data
      });

   register = user => axios.post(`${API_URL}auth/signup`, {
      username: user.username,
      email: user.email,
      password: user.password,
   });

   logout = () => {
      axios.post(`${API_URL}auth/logout`).then(() => {
         localStorage.removeItem('userData')
         return true
      })
   };

   /**
    * Check if token is valid by calling /auth/check-token endpoint
    * @returns Promise with response data or rejects with error
    */
   checkToken = () => {
      const user = JSON.parse(localStorage.getItem('userData'))
      const token = user ? user.token : null

      if (!token) {
         return Promise.reject(new Error('No token available'))
      }

      return axios.get(`${API_URL}auth/check-token`, {
         headers: {
            Authorization: `Bearer ${token}`,
         },
      })
   }
}

export default new AuthService()
